import request from "@/utils/request"

// 二维码产品描述
export function GetProductIntroduceOut(id) {
  return request({
    url: "/QRCode/QRCode/GetProductIntroduceOut",
    method: "get",
    params: { id },
  })
}

// 二维码产品描述内容
export function GetProductIntroduceContentOut(id) {
  return request({
    url: "/QRCode/QRCode/GetProductIntroduceContentOut",
    method: "get",
    params: { id },
  })
}

// 获取机器号下拉
export function getUnitNumbers(params) {
  return request({
    url: "/Mart/AfterSales/GetUnitNumbers",
    method: "get",
    params,
  })
}

// 故障类型下拉
export function getErrorTypes(params) {
  return request({
    url: "/Mart/AfterSales/GetErrorTypes",
    method: "get",
    params,
  })
}

// 省
export function getProvinces(params) {
  return request({
    url: "/Mart/Other/GetProvinces",
    method: "get",
    params,
  })
}

// 市
export function getCitiesByProvinceID(params) {
  return request({
    url: "/Mart/Other/GetCitiesByProvinceID",
    method: "get",
    params,
  })
}

// 上传
export function upload(params) {
  return request({
    url: "/api/Upload/Upload",
    method: "POST",
    data: params,
  })
}

// 售后单申报
export function declareAfterSalesOrder(params) {
  return request({
    url: "/Mart/AfterSales/DeclareAfterSalesOrder",
    method: "POST",
    data: params,
  })
}

// 查询售后申报单列表
export function afterSalesOrderList(params) {
  return request({
    url: "/Mart/AfterSales/AfterSalesOrderList",
    method: "POST",
    data: params,
  })
}

// 通过ID获取售后详情
export function getAfterSalesOrder(params) {
  return request({
    url: "/Mart/AfterSales/GetAfterSalesOrder",
    method: "GET",
    params,
  })
}

// 获取跟进信息
export function aftersalesFollowList(params) {
  return request({
    url: "/Mart/AfterSales/AftersalesFollowList",
    method: "POST",
    data: params,
  })
}
